import {
  take,
  fork,
  cancel,
  call,
  put,
  cancelled,
  takeEvery
} from 'redux-saga/effects'
import { push } from 'redux-first-history'
import CryptoJS from 'crypto-js'
import jwtDecode from 'jwt-decode'
import _ from 'lodash'
import {
  LOGIN_FORM_SUBMIT,
  CLIENT_UNSET,
  LOGOUT,
  KVT_IDENTITY_SERVER,
  GET_LANG_FROM_SITE,
  VALIDATE_TOKEN
} from '../constants'
import {
  loginFormSubmitSuccess,
  loginFormSubmitFailed,
  setClient,
  unsetClient,
  handleChangeLang,
  updateTaxCard,
  getAllAssignments,
  getAssignmentOfferToEmail,
  trackApplication,
  loadOpenForWorkStart,
  getWorkshiftUser
} from '../actions'
import { registerPost } from '../utils/request'
import { langQuery } from '../utils/website.utils'
import store from '../store'

/**
 * login.saga of employer side is copied to develop separately with user side
 * if this original is updated, let check and done the same things with employer side
 */

/**
 * @author Pragya Gupta
 *
 */

function* loginFlow(values) {
  let user
  try {
    const url = `${KVT_IDENTITY_SERVER}/CheckUser`
    const refinedForm = Object.assign({}, { ...values })
    const hashedPassword = CryptoJS.SHA256(refinedForm.password).toString()

    const body = JSON.stringify({
      email: refinedForm.email,
      password: hashedPassword,
      SubjectId: refinedForm.email,
      usertype: 'user'
    })

    user = yield call(registerPost, url, body)

    //For unregistered users! Backend sends different data format
    if (user.data[0] === 'user not found') {
      yield put(loginFormSubmitFailed(user.data[0]))
      yield put(unsetClient())
      sessionStorage.removeItem('user')
      yield put(push('/dashboard/login'))
    } else if (!!user.data[0].access_token) {
      yield put(setClient(user))
      sessionStorage.setItem('user', JSON.stringify(user))
      yield put(loginFormSubmitSuccess())

      //update tax card on login
      yield put(updateTaxCard(false, true))
      yield put(getAllAssignments())
      yield put(getAssignmentOfferToEmail())
      yield put(trackApplication())
      yield put(loadOpenForWorkStart())
      yield put(getWorkshiftUser())

      yield put(push('/dashboard/main'))
    } else {
      // Incase password is not valid!
      yield put(loginFormSubmitFailed(user.data[0].error_description))
      yield put(unsetClient())
      sessionStorage.removeItem('user')
      yield put(push('/dashboard/login'))
    }
  } catch (error) {
    yield put(loginFormSubmitFailed(error))
    yield put(unsetClient())
    sessionStorage.removeItem('user')
    yield put(push('/dashboard/login'))
  } finally {
    if (yield cancelled()) {
      yield put(push('/dashboard/login'))
    }
    return user
  }
}

function* logout() {
  yield put(unsetClient())
  sessionStorage.removeItem('user')
  yield put(push('/dashboard/login'))
}

function* getLangFromSite() {
  try {
    let searchQuery = store.getState().router.location.search
    let stringIncludes = 'trp-form-language'

    if (searchQuery !== '') {
      const siteLang = langQuery(searchQuery, stringIncludes)
      yield put(handleChangeLang(siteLang))
    }
  } catch (error) {
    // console.warn(error)
  }
}

export function* tokenValidationSaga({ isUserActive }) {
  const token =
    store.getState().client.user &&
    !_.isEmpty(store.getState().client.user.data) &&
    store.getState().client.user.data[0].access_token

  var oldDateObj = new Date()
  var newDateObj = new Date()
  newDateObj.setTime(oldDateObj.getTime() + 18 * 60 * 1000) // 5 minutes before it expires

  const isExpired = token && jwtDecode(token).exp < newDateObj / 1000
  //console.log('isTokenExpired', isExpired)
  //console.log('isUserActive', isUserActive)

  if (isUserActive && isExpired) {
    // console.log('refeshing token')
    yield call(refreshTokenSaga)
  } else if (isUserActive == false && isExpired) {
    // console.log('logout')
    yield call(logout)
    // delete browser cache and hard reload
    //window.location.reload()
  } else {
    // console.log('okay')
  }
}

export function* refreshTokenSaga() {
  let user
  try {
    const url = `${KVT_IDENTITY_SERVER}/RenewTokens`
    const uuid = store.getState().client.user.data[2]
    const email = store.getState().client.user.data[1]
    const body = JSON.stringify({
      uuid,
      email
    })

    user = yield call(registerPost, url, body)

    // console.log('>>>>>>>>>>>>>>userToken refesh successfully!')
    yield put(setClient(user))
  } catch (error) {
    // console.log('>>>>>>>>>>>>>>>userToken refesh error!')
  }
}

export function* watchLoginSaga() {
  while (true) {
    const { values } = yield take(LOGIN_FORM_SUBMIT)
    const task = yield fork(loginFlow, values)
    const action = yield take([CLIENT_UNSET, loginFormSubmitFailed])
    if (action.type === CLIENT_UNSET) yield cancel(task)
    //yield call(logout)
  }
}

export function* watchLogoutSaga() {
  yield takeEvery(LOGOUT, logout)
}

export function* watchGetLangFromSiteSaga() {
  yield takeEvery(GET_LANG_FROM_SITE, getLangFromSite)
}

export function* watchTokenValidation() {
  yield takeEvery(VALIDATE_TOKEN, tokenValidationSaga)
}
